<template>
  <div class="container" ref="container">
    <!-- :style="{ height: second && second.imgUrl ? '800px' : 'auto' }" -->
    <img
      class="img"
      @load="handleImgLoad($refs['container'], baseUrl + second.imgUrl)"
      v-if="second && second.imgUrl"
      :src="baseUrl + second.imgUrl"
    />
    <div v-if="second" class="j-container ">
      <div class="j-title title">{{ second.title }}</div>

      <div class="j-content network-desc" v-html="second.articleTxt"></div>
    </div>
    <div v-if="loaded && !second" class="j-coming-soon j-content">
      {{ $t('common.coming_soon') }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'SalesNetwork',
  data() {
    return {
      baseUrl
    };
  },
  props: {
    second: {
      required: true,
      default: () => {
        return null;
      }
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleImgLoad(container, src) {
      if (container && src) {
        const img = new Image();
        img.src = src;
        const oriHeight = img.height;

        container.style.height = `${oriHeight}px`;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 80px;

  .title {
    margin-bottom: 30px;
    text-align: center;
  }

  position: relative;
  z-index: 1;

  img {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
